var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<div class=\"notification\">\n  <h3 class=\"notification__head\">Final Sale</h3>\n  <p class=\"notification__description\">Sample or customer return, exhibits very slight scuffing on the soles. 10% off, no coupons</p>\n  <p class=\"notification__description\">No returns or exchanges</p>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/product-notifications/final-sale-sample-defect.html
// module id = 160
// module chunks = 0